import "./withdrawal.css";
import { Link } from "react-router-dom";
import React, { useState, useEffect, Component } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowRight } from "@fortawesome/free-solid-svg-icons";
import Chairman from "../images/Chairman.jpg";
import MainBg from "../images/Leadership main bg.jpg";
import men from "../images/men.png";
import Mobilemen from "../images/mobile-men.png";
import Ceo from "../images/Ojiromayo.jpg";
import ED from "../images/Abayomi.jpg";
import Internal from "../images/Yomi.jpg";
import InternalAud from "../images/Segun.jpg";
import RiskMMng from "../images/Kingsley.jpg";
import ready from "../images/avc-ready.jpg";
import benefits from "../images/avc-benefits.jpg";
import withdrawalBanner from "../images/withdrawal-banner.jpg";
import health from "../images/health.png";
import foreign from "../images/foreign.png";
import missing from "../images/missing.png";
import people from "../images/people.png";
import calendar from "../images/calendar.png";
import time from "../images/time.png";
import withdrawalStart from "../images/withdrawal-start.png";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import { ApolloClient, HttpLink, InMemoryCache, gql } from "@apollo/client";
import { ApolloProvider } from "@apollo/client/react";
import Footer from "./footer";
import AOS from 'aos';

const client = new ApolloClient({
  link: new HttpLink({
    uri: "https://pensure-cms.inspireleadership.biz/graphql",
  }),
  cache: new InMemoryCache(),
});

const Withdrawal = () => {
  window.scrollTo(0, 0);

  const [heroBanner, setHeroBanner] = useState([]);
  const [heroMobile, setHeroMobile] = useState([]);
  const [businessSections, setBusinessSections] = useState([]);
  const [productInfo, setProductInfo] = useState([]);


                     useEffect( () => {
                           AOS.init({
                                offset: 0,
                                duration: 1000,
                                once: true
                                  });
                                 }, [])

  useEffect(() => {
    client
      .query({
        query: gql`
          query NewQuery {
            pages {
              nodes {
                withdrawals {
                  productInfo {
                    explanation
                    heading
                    icon {
                      mediaItemUrl
                    }
                  }
                  heromobile {
                    buttonlink
                    buttontext
                    herocaption
                    herosubcaption
                    image {
                      mediaItemUrl
                    }
                  }
                  hero {
                    buttonlink
                    buttontext
                    herocaption
                    herosubcaption
                    image {
                      mediaItemUrl
                    }
                  }
                  section {
                    buttonLink
                    buttonName
                    caption
                    heading
                    image {
                      mediaItemUrl
                    }
                  }
                }
              }
            }
          }
        `,
      })
      .then((result) => {
        console.log(result);

        setHeroBanner(result.data.pages.nodes[0].withdrawals.hero);
        setHeroMobile(result.data.pages.nodes[0].withdrawals.heromobile);
        setBusinessSections(result.data.pages.nodes[0].withdrawals.section);
        setProductInfo(result.data.pages.nodes[0].withdrawals.productInfo);
      });
  }, []);

  let businessSectionsDisplay;
  let productInfoDisplay;
  let heroBannerDisplay;
  let heroMobileDisplay;

  if (heroBanner.length > 0) {
    heroBannerDisplay = heroBanner.map((banner, i) => (
      <div className="mp-cover">
        <img className="mp-bg" src={banner.image.mediaItemUrl} />
        <div className="mp-content">
          <div className="withdrawal-txt">
            <h1 className="mp-h1 " data-aos="zoom-in" data-aos-delay="200">{banner.herocaption}</h1>
            <p className="grey-p" data-aos="fade-up" data-aos-delay="200">{banner.herosubcaption} </p>
            <a href={banner.buttonLink} className="btn-trns" data-aos="fade-up" data-aos-delay="200">
              {" "}
              {banner.buttontext}{" "}
              <FontAwesomeIcon icon={faArrowRight} className="grey-arrw" />
            </a>
          </div>
        </div>
      </div>
    ));
  }

  if (heroMobile.length > 0) {
    heroMobileDisplay = heroMobile.map((banner, i) => (
      <div className="mp-cover">
        <img className="mp-bg" src={banner.image.mediaItemUrl} />
        <div className="mp-content">
          <div className="withdrawal-txt">
            <h1 className="mp-h1" data-aos="fade-up" data-aos-delay="200">{banner.herocaption}</h1>
            <p className="grey-p" data-aos="fade-up" data-aos-delay="200">{banner.herosubcaption} </p>
            <a href={banner.buttonLink} className="btn-trns" data-aos="fade-up" data-aos-delay="200">
              {" "}
              {banner.buttontext}{" "}
              <FontAwesomeIcon icon={faArrowRight} className="grey-arrw" />
            </a>
          </div>
        </div>
      </div>
    ));
  }

  if (productInfo.length > 0) {
    productInfoDisplay = productInfo.map((info, i) => (
      <div className="card withdrawal-crd">
        <div className="text-start">
          <img className="pb-5" src={info.icon.mediaItemUrl} data-aos="fade-up" data-aos-delay="200"/>
          <h4 className="card-subtitle mb-1 statements-hdr" data-aos="fade-up" data-aos-delay="200">{info.heading}</h4>
          <p className="card-text pt-3 grey-p-withdrawal" data-aos="fade-up" data-aos-delay="200">{info.explanation}</p>
        </div>
      </div>
    ));
  }

  if (businessSections.length > 0) {
    businessSectionsDisplay = businessSections.map((section, i) =>
      i % 2 ? (
        <div
          id="mobile-view"
          className=" d-flex align-items-center justify-content-between padding-section-standard-top pb-5 z-value"
        >
          <div className="d-flex justify-content-end">
            <img className="img-fluid" src={section.image.mediaItemUrl} />
          </div>

          <div className="values compact-section">
            <h3 className="h3 rsa-h3" data-aos="fade-up" data-aos-delay="200"> {section.heading} </h3>
            <p
              className="grey-p pt-3 pb-5"
              style={{ fontSize: "16px", color: "#545454" }}
              data-aos="fade-up" data-aos-delay="200"
            >
              {section.caption}
            </p>

            <a
              class="open-acc-btn grey-p mt-3"
              href={section.buttonLink}
              role="button"
              data-aos="fade-up" data-aos-delay="200"
    
            >
              {section.buttonName}
              <FontAwesomeIcon className="rsa-dwn-arr" icon={faArrowRight} />
            </a>
          </div>
        </div>
      ) : (
        <div
          id="mobile-view"
          className=" d-flex align-items-center justify-content-between padding-section-standard-top pb-5 z-value"
        >
          <div className="values-withdrawal compact-section">
            <h3 className="h3 rsa-h3" data-aos="fade-up" data-aos-delay="200">{section.heading} </h3>
            <p
              className="grey-p pt-3 pb-5"
              style={{ fontSize: "16px", color: "#545454" }}
              data-aos="fade-up" data-aos-delay="200"
            >
              {section.caption}
            </p>

            <a
              class="open-acc-btn grey-p mt-3"
              href={section.buttonLink}
              role="button"
              data-aos="fade-up" data-aos-delay="200"
            >
              {section.buttonName}{" "}
              <FontAwesomeIcon className="rsa-dwn-arr" icon={faArrowRight} />
            </a>
          </div>

          <div className="d-flex justify-content-end">
            <img className="withdrawal-img" src={section.image.mediaItemUrl} />
          </div>
        </div>
      ),
    );
  }

  return (
    <>
      <div className="mp-container d-none d-sm-block">{heroBannerDisplay}</div>

      <div className="mp-container d-block d-sm-none">{heroMobileDisplay}</div>

      <div className="plain-cont padding-section-standard-top">
        <div
          id="mobile-view-withdrawal"
          className="containeer row d-flex flex-wrap justify-content-between text-center "
        >
          <div className="text-center pb-5">
            <p className="orange-p-withdrawal pb-2">BENEFIT ELIGIBILITY</p>
            <h2 className="withdrawal-h2 dark-text">
              When Can You Access Your <br /> Pensions Savings ?
            </h2>
            <p className="grey-p-withdrawal dark-text-2">
              See the valid reasons RSA holders or beneficiaries can access
              pension funds.
            </p>
          </div>
          <div id="mobile-view" className="d-flex justify-content-between">
            {productInfoDisplay}
          </div>
        </div>
      </div>

      <div className="containeer">{businessSectionsDisplay}</div>
           <Footer/>
           <div className='height-prod'> 

              </div>
    </>
  );
};

export default Withdrawal;
